import {Power0} from 'gsap';
import {startAnimeProgressLine} from '../animationGraphick';
import {animatinGears} from '../rotateGears';
import helpers from '../../../helpers';

let scheme = null;

const reset = () => {
	scheme = document.querySelector('.scheme-2-1 svg');

	const reactor = scheme.querySelector('.reactor-inner');
	const lines = scheme.querySelectorAll('.progress-bar');

	gsap.set(reactor, {
		x: -200,
	});

	lines.forEach((element) => {
		const path = element.getTotalLength();

		gsap.set(element, {
			strokeDashoffset: path,
			strokeDasharray: `${path}, ${path}`,
		});
	});
};

reset();

const time = 5;

const animationReactor = () => {
	const reactor = scheme.querySelector('.reactor-inner');
	const forward = gsap.timeline({paused: true});
	const back = gsap.timeline({paused: true});

	back.to(reactor, {
		onComplete() {
			forward.play();
			forward.restart();
		},
		ease: Power0.easeNone,
		x: -200,
	});

	forward.to(reactor, {
		onComplete() {
			back.restart();
		},
		duration: time,
		ease: Power0.easeNone,
		x: 200,
	});

	back.play();
};

const initAnimationPartTwo = () => {
	animationReactor();
	animatinGears(scheme);

	if (!helpers.isMobile()) {
		startAnimeProgressLine(scheme);
	}
};

export {initAnimationPartTwo};
